import { render, staticRenderFns } from "./CompanyService2.vue?vue&type=template&id=6de5c889"
import script from "./CompanyService2.vue?vue&type=script&lang=js"
export * from "./CompanyService2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports